import React, { useCallback } from 'react';
import { isEmpty, extensionName } from '../../../../helpers/common';
import { MessageReplyInterface } from '../../../../interfaces/chatMessageInterface';
import dayjs from 'dayjs';
import RenderHtml from '../../../renderHtml';
import FileSVGIcon from '../../../../assets/images/svg/filesIconSvg';
import { FILE_EXTENSIONS, FILE_TYPES } from '../../../../global/constants';
import { FileIconDiv, FileType } from '../fileAttachments/styles';

interface ReplyQuoteProps {
  reply: MessageReplyInterface | undefined;
  getReplyMessage: (reply: MessageReplyInterface | undefined) => string | undefined;
}

const ReplyQuote: React.FC<ReplyQuoteProps> = ({ reply, getReplyMessage }) => {
  const handleClick = useCallback(() => {
    const repliedMessage = document.getElementById(reply?.id || '');
    if (repliedMessage) {
      repliedMessage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [reply?.id]);
  return (
    <div
      role='button'
      className='thread-div'
      onClick={handleClick}>
      <div className='content'>
        <div className='line' />

        <div className='right-div'>
          <div className='header'>
            <div className='left-header'>
              <div className='name'>{reply?.sender || ''}</div>
              <div className='time'>{dayjs(reply?.createdOn).format('hh:mm a')}</div>
            </div>
          </div>
          {!isEmpty(reply?.message) && <RenderHtml htmlString={getReplyMessage(reply) || ''} />}
          {!isEmpty(reply?.files) && (
            <div className='file-div'>
              {reply?.files?.map((file) => {
                const extension = extensionName(file).toLowerCase();
                return (
                  <div key={file?.name} className='image-div'>
                    {(!file?.uploadFileType || file?.uploadFileType === FILE_TYPES.UPLOAD) &&
                    !FILE_EXTENSIONS.includes(extension) ? (
                      <FileIconDiv>
                        <FileSVGIcon name={'blank'} height='32' width='32' viewBox='0 0 60 60' />
                        <FileType fontSize={extension?.length <= 4 ? 7 : 5} className='file-text'>
                          {extension?.length <= 5 && extension?.split('.')?.pop()?.toUpperCase()}
                        </FileType>
                      </FileIconDiv>
                    ) : (
                      <FileSVGIcon
                        name={
                          !file?.uploadFileType || file?.uploadFileType === FILE_TYPES.UPLOAD
                            ? extension
                            : `icon_${file?.uploadFileType}`
                        }
                        height='32'
                        width='32'
                        viewBox='0 0 60 60'
                      />
                    )}

                    <div className='filetext'>{file?.name}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ReplyQuote);
